import React from 'react'

import {
  // Box,
  Grid,
  Paper,
  Typography,
  // Card,
  // CardContent,
  // Button,
  Chip,
  // Dialog,
  // DialogTitle,
  // DialogContent,
  // DialogActions,
  // LinearProgress,
  Avatar,
  // Divider,
  // Stack,
  // IconButton,
  // Tooltip,
  // useMediaQuery,
  // useTheme,
  // Fade,
  // Snackbar,
  // Alert,
  // TextField,
  // CircularProgress,
  // List,
  // ListItem,
  // ListItemAvatar,
  // ListItemText,
  // ListItemSecondaryAction,
  // Tab,
  // Tabs,
  // Badge,
  Zoom,
  // RadioGroup,
  // FormControlLabel,
  // Radio,
  // Container,
} from '@mui/material';
import {
  FaCoins,
  // FaGift,
  // FaExchangeAlt,
  // FaHistory,
  // FaCheckCircle,
  FaClock,
  // FaTimesCircle,
  // FaWallet,
  // FaStar,
  FaTrophy,
  // FaMedal,
  // FaAward,
  // FaLeaf,
  // FaTree,
  // FaRecycle,
  // FaWater,
  // FaCloud,
  // FaTrashAlt,
  // FaShoppingCart,
  // FaMoneyBillWave,
  // FaMobile,
  // FaMobileAlt,
  // FaPhone,
  // FaWhatsapp,
  // FaFlag,
  // FaBan,
} from 'react-icons/fa';

export default function SummaryCards({isMobile, points}) {
    // console.log(points)
  return (
    <Grid
  container
  spacing={3}
  justifyContent="center"
  alignItems="stretch"
  sx={{
    width: '100%',
    maxWidth: '1400px',
    mx: 'auto',
  }}
>
  {/* Total Earned Points */}
  <Grid
    item
    xs={12}
    sm={6}
    md={4}
    sx={{
      display: 'flex',
      flex: {
        xs: '1 1 100%',
        sm: '1 1 calc(50% - 12px)',
        md: '1 1 calc(33.333% - 16px)',
      },
      maxWidth: {
        xs: '100%',
        sm: 'calc(50% - 12px)',
        md: 'calc(33.333% - 16px)',
      },
    }}
  >
    <Zoom
      in={true}
      style={{ transitionDelay: '50ms', width: '100%' }}
    >
      <Paper
        elevation={6}
        sx={{
          p: isMobile ? 3 : 4,
          borderRadius: '20px',
          textAlign: 'center',
          background: 'linear-gradient(135deg, #1b5e20, #2e7d32)',
          width: '100%',
          height: '100%',
          minHeight: isMobile ? 160 : 200,
          transition: 'all 0.3s ease',
          position: 'relative',
          overflow: 'hidden',
          border: '1px solid rgba(255,255,255,0.1)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: '0 12px 40px rgba(46,125,50,0.4)',
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -80,
            right: -80,
            width: 160,
            height: 160,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -60,
            left: -60,
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.03)',
          },
        }}
      >
        <Avatar
          sx={{
            bgcolor: 'rgba(255,255,255,0.2)',
            width: isMobile ? 56 : 72,
            height: isMobile ? 56 : 72,
            mx: 'auto',
            mb: 1.5,
          }}
        >
          <FaTrophy
            size={isMobile ? 28 : 36}
            color="#a5d6a7"
          />
        </Avatar>

        <Typography
          variant={isMobile ? 'h3' : 'h2'}
          fontWeight="bold"
          sx={{
            color: '#fff',
            mb: 0.5,
          }}
        >
          {points?.totalEarned || 0}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: 'rgba(255,255,255,0.9)',
            fontWeight: 500,
          }}
        >
          Total Earned Points
        </Typography>

        <Chip
          label="Lifetime"
          size="small"
          sx={{
            mt: 1.5,
            bgcolor: 'rgba(255,255,255,0.2)',
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.7rem',
          }}
        />
      </Paper>
    </Zoom>
  </Grid>

  {/* Redeemable Points */}
  <Grid
    item
    xs={12}
    sm={6}
    md={4}
    sx={{
      display: 'flex',
      flex: {
        xs: '1 1 100%',
        sm: '1 1 calc(50% - 12px)',
        md: '1 1 calc(33.333% - 16px)',
      },
      maxWidth: {
        xs: '100%',
        sm: 'calc(50% - 12px)',
        md: 'calc(33.333% - 16px)',
      },
    }}
  >
    <Zoom
      in={true}
      style={{ transitionDelay: '100ms', width: '100%' }}
    >
      <Paper
        elevation={6}
        sx={{
          p: isMobile ? 3 : 4,
          borderRadius: '20px',
          textAlign: 'center',
          background: 'linear-gradient(135deg, #01579b, #0277bd)',
          width: '100%',
          height: '100%',
          minHeight: isMobile ? 160 : 200,
          transition: 'all 0.3s ease',
          position: 'relative',
          overflow: 'hidden',
          border: '1px solid rgba(255,255,255,0.1)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: '0 12px 40px rgba(2,119,189,0.4)',
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -80,
            right: -80,
            width: 160,
            height: 160,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -60,
            left: -60,
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.03)',
          },
        }}
      >
        <Avatar
          sx={{
            bgcolor: 'rgba(255,255,255,0.2)',
            width: isMobile ? 56 : 72,
            height: isMobile ? 56 : 72,
            mx: 'auto',
            mb: 1.5,
          }}
        >
          <FaCoins
            size={isMobile ? 28 : 36}
            color="#a5d6a7"
          />
        </Avatar>

        <Typography
          variant={isMobile ? 'h3' : 'h2'}
          fontWeight="bold"
          sx={{
            color: '#fff',
            mb: 0.5,
          }}
        >
          {points?.redeemable || 0}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: 'rgba(255,255,255,0.9)',
            fontWeight: 500,
          }}
        >
          Redeemable Points
        </Typography>

        <Chip
          label="Available"
          size="small"
          sx={{
            mt: 1.5,
            bgcolor: 'rgba(255,255,255,0.2)',
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.7rem',
          }}
        />
      </Paper>
    </Zoom>
  </Grid>

  {/* Pending Points */}
  <Grid
    item
    xs={12}
    sm={6}
    md={4}
    sx={{
      display: 'flex',
      flex: {
        xs: '1 1 100%',
        sm: '1 1 calc(50% - 12px)',
        md: '1 1 calc(33.333% - 16px)',
      },
      maxWidth: {
        xs: '100%',
        sm: 'calc(50% - 12px)',
        md: 'calc(33.333% - 16px)',
      },
    }}
  >
    <Zoom
      in={true}
      style={{ transitionDelay: '150ms', width: '100%' }}
    >
      <Paper
        elevation={6}
        sx={{
          p: isMobile ? 3 : 4,
          borderRadius: '20px',
          textAlign: 'center',
          background: 'linear-gradient(135deg, #e65100, #f57c00)',
          width: '100%',
          height: '100%',
          minHeight: isMobile ? 160 : 200,
          transition: 'all 0.3s ease',
          position: 'relative',
          overflow: 'hidden',
          border: '1px solid rgba(255,255,255,0.1)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          '&:hover': {
            transform: 'translateY(-6px)',
            boxShadow: '0 12px 40px rgba(245,124,0,0.4)',
          },
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -80,
            right: -80,
            width: 160,
            height: 160,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.05)',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -60,
            left: -60,
            width: 120,
            height: 120,
            borderRadius: '50%',
            background: 'rgba(255,255,255,0.03)',
          },
        }}
      >
        <Avatar
          sx={{
            bgcolor: 'rgba(255,255,255,0.2)',
            width: isMobile ? 56 : 72,
            height: isMobile ? 56 : 72,
            mx: 'auto',
            mb: 1.5,
          }}
        >
          <FaClock
            size={isMobile ? 28 : 36}
            color="#ffcc80"
          />
        </Avatar>

        <Typography
          variant={isMobile ? 'h3' : 'h2'}
          fontWeight="bold"
          sx={{
            color: '#fff',
            mb: 0.5,
          }}
        >
          {points?.pending || 0}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            color: 'rgba(255,255,255,0.9)',
            fontWeight: 500,
          }}
        >
          Pending Points
        </Typography>

        <Chip
          label="Processing"
          size="small"
          sx={{
            mt: 1.5,
            bgcolor: 'rgba(255,255,255,0.2)',
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.7rem',
          }}
        />
      </Paper>
    </Zoom>
  </Grid>
</Grid>
  )
}
